module.exports = __webpack_public_path__ + "img/spinner.45a4f14f.png";